// Roadmap status helpers
//
// Templates (global roadmap templates) only support three statuses. The status a
// template carries is the status a client's roadmap card starts with when the
// client roadmap is first generated from the templates.
//
// Client roadmap cards additionally support 'completed'.

export const TEMPLATE_STATUSES = [
  { value: 'not-started', label: 'Not Started' },
  { value: 'in-progress', label: 'In Progress' },
  { value: 'hidden', label: 'Hidden (Internal Only)' },
];

export const CLIENT_ROADMAP_STATUSES = [
  { value: 'not-started', label: 'Not Started' },
  { value: 'in-progress', label: 'In Progress' },
  { value: 'completed', label: 'Completed' },
  { value: 'hidden', label: 'Hidden (Internal Only)' },
];

export const DEFAULT_ROADMAP_STATUS = 'not-started';

const TEMPLATE_STATUS_VALUES = TEMPLATE_STATUSES.map((s) => s.value);
const CLIENT_STATUS_VALUES = CLIENT_ROADMAP_STATUSES.map((s) => s.value);

const normalize = (status) => String(status || '').trim().toLowerCase();

/** Status of a global template — 'completed' is not a template status. */
export const normalizeTemplateStatus = (status) => {
  const value = normalize(status);
  return TEMPLATE_STATUS_VALUES.includes(value) ? value : DEFAULT_ROADMAP_STATUS;
};

/** Status of a client roadmap card. */
export const normalizeClientRoadmapStatus = (status) => {
  const value = normalize(status);
  return CLIENT_STATUS_VALUES.includes(value) ? value : DEFAULT_ROADMAP_STATUS;
};

/**
 * Starting status for a client roadmap card created from a template.
 * A template marked hidden/in progress/not started seeds the client card the same way.
 */
export const statusFromTemplate = (template) => normalizeTemplateStatus(template?.status);

export const getRoadmapStatusLabel = (status) => {
  const value = normalizeClientRoadmapStatus(status);
  return CLIENT_ROADMAP_STATUSES.find((s) => s.value === value)?.label || 'Not Started';
};
